var ie = Object.defineProperty, de = Object.defineProperties;
var ue = Object.getOwnPropertyDescriptors;
var $ = Object.getOwnPropertySymbols;
var pe = Object.prototype.hasOwnProperty, fe = Object.prototype.propertyIsEnumerable;
var A = (p, u, d) => u in p ? ie(p, u, { enumerable: !0, configurable: !0, writable: !0, value: d }) : p[u] = d, y = (p, u) => {
  for (var d in u || (u = {}))
    pe.call(u, d) && A(p, d, u[d]);
  if ($)
    for (var d of $(u))
      fe.call(u, d) && A(p, d, u[d]);
  return p;
}, C = (p, u) => de(p, ue(u));
var T = (p, u, d) => new Promise((k, a) => {
  var H = (f) => {
    try {
      t(d.next(f));
    } catch (N) {
      a(N);
    }
  }, M = (f) => {
    try {
      t(d.throw(f));
    } catch (N) {
      a(N);
    }
  }, t = (f) => f.done ? k(f.value) : Promise.resolve(f.value).then(H, M);
  t((d = d.apply(p, u)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import me from "../formMixin.js";
import { postRuleValidate as G } from "../../../../request/commoditycenter/form/ruleValidate/post.js";
import { postCodes as ce } from "../../../../request/commoditycenter/commodity/classification/dictionary/rela/codes/post.js";
import { useLanguage as he } from "../../../../utils/useLanguage.js";
import { defineComponent as ge, useTemplateRef as ve, watch as j, computed as P, onMounted as we, openBlock as F, createElementBlock as K, createElementVNode as v, createVNode as r, withCtx as n, createBlock as Q, createCommentVNode as ye, createTextVNode as U, Fragment as be, nextTick as Me } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as Ne } from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as O, unref as e } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import xe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import _e from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import Ce from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import Te from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Row.js";
import h from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Col.js";
import g from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import R from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import B from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input-number/src/InputNumber.js";
import { toDisplayString as b } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import ke from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import He from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import X from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import Y from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import Le from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const We = { class: "tw:flex tw:items-center" }, Se = { class: "tw:text-[#909399]" }, Fe = { style: { display: "flex", "justify-content": "center", gap: "8px", "margin-top": "16px" } }, lt = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "lianshenhuabian",
  props: {
    options: {},
    locale: {}
  },
  emits: ["hide-dialog", "onSuccess"],
  setup(p, { expose: u, emit: d }) {
    const { i18n: k } = he(), { t: a } = k.global, H = ve("lianshenHuabian"), { formSelect: M, formData: t, rules: f, allowEditFun: N, setDefault: Z, setRequired: ee } = me(), x = Ne(), I = p;
    j(
      () => I.locale,
      (s) => {
        k.global.locale.value = s || "zh-CN";
      },
      { immediate: !0 }
    );
    const V = d, m = O(!1), E = O(!0), w = O(null), te = O(null), L = (s) => {
      var o;
      return (((o = M.value.find((i) => i.code === s)) == null ? void 0 : o.values) || []).filter((i) => i.valueCode !== "");
    }, c = (s) => N(M.value, s), le = P(() => {
      const { openModel: s, productHeight: l, productWidth: o, pleatinMultiple: i } = t;
      return !!(s && l || o && i);
    }), oe = P(() => {
      var i, W;
      const s = { required: !0, trigger: "change" }, l = t.flowerType, o = (_) => ({
        validator(q, S) {
          return S == null ? new Error(_) : !0;
        },
        trigger: ["change", "blur", "input"]
        // 修改此处，移除 as const
      });
      return C(y({}, Object.fromEntries(
        Object.entries(f).filter(
          ([_]) => !["openModel", "pleatinMultiple", "productHeight", "productWidth"].includes(_)
        )
      )), {
        // 动态规则：直接访问 rules.openModel（响应式字段）
        openModel: (i = f.openModel) != null && i.length ? f.openModel : t.flowerType === "竖向花边" ? [C(y({}, s), { message: "开合方式必填！" })] : [],
        pleatinMultiple: (W = f.pleatinMultiple) != null && W.length ? f.pleatinMultiple : t.flowerType === "横向花边" ? [C(y({}, s), { message: "打褶倍数必填！" })] : [],
        // productHeight: rules.productHeight?.length
        //   ? rules.productHeight
        //   : (formData.flowerType === '竖向花边' ? [{ ...rule, message: '成品高必填！' }] : []),
        // productWidth: rules.productWidth?.length
        //   ? rules.productWidth
        //   : (formData.flowerType === '横向花边' ? [{ ...rule, message: '成品宽必填！' }] : []),
        productHeight: l === "竖向花边" ? [o("成品高必填！")] : [],
        productWidth: l === "横向花边" ? [o("成品宽必填！")] : []
      });
    }), ae = () => T(this, null, function* () {
      var s;
      try {
        const { flowerType: l, openModel: o, productHeight: i, productWidth: W, pleatinMultiple: _ } = t, q = {
          productLength: t.productLength,
          flowerType: l,
          openModel: o,
          productHeight: Number(i || 0),
          productWidth: Number(W || 0),
          pleatinMultiple: Number(_ || 0),
          roomName: t.roomName,
          isStandard: t.isStandard,
          urgent: t.urgent,
          deliveryMethod: t.deliveryMethod
        }, S = l === "横向花边" ? "FL_lianshenhuabian_hx" : "FL_lianshenhuabian_sx";
        m.value = !0;
        const J = yield G([
          {
            data: JSON.stringify(q),
            classificationCode: S
          }
        ]);
        m.value = !1, J.status && (x.success("计算成功"), t.productLength = (s = J.data) == null ? void 0 : s.productLength);
      } catch (l) {
        m.value = !1, x.error("计算失败，请重试"), console.error("计算错误:", l);
      }
    }), D = () => {
      V("hide-dialog");
    }, re = () => T(this, null, function* () {
      var s;
      if (w.value)
        try {
          yield w.value.validate(), (t.hole !== void 0 && t.hole > 0 || t.diagonalCurtain !== "无" || t.isSpecial === "是") && (t.isStandard = "是");
          const l = C(y({}, t), {
            productHeight: Number(t.productHeight || 0),
            productWidth: Number(t.productWidth || 0),
            pleatinMultiple: Number(t.pleatinMultiple || 0)
          }), o = t.flowerType === "横向花边" ? "FL_lianshenhuabian_hx" : "FL_lianshenhuabian_sx";
          m.value = !0;
          const i = yield G([
            {
              data: JSON.stringify(l),
              classificationCode: o
            }
          ]);
          m.value = !1, i.status ? (x.success("提交成功"), t.productLength = (s = i.data) == null ? void 0 : s.productLength, V("onSuccess", y({}, t)), V("hide-dialog")) : x.error(i.message || "操作失败，请检查输入项");
        } catch (l) {
          m.value = !1, console.error("提交失败:", l);
        }
    }), se = (s) => T(this, null, function* () {
      var l;
      (l = w.value) == null || l.restoreValidation(), s === "横向花边" ? (t.openModel = "", t.productHeight = null) : s === "竖向花边" && (console.log("竖向花边"), t.pleatinMultiple = "", t.productWidth = null), yield Me(), console.log(t, "formData");
    }), z = () => T(this, null, function* () {
      const { commodityId: s } = I.options;
      if (!s) {
        console.warn("缺少commodityId，无法获取分类数据");
        return;
      }
      try {
        m.value = !0;
        const l = yield ce({
          commodityId: String(s),
          classificationCode: "FL_lianshenhuabian",
          codes: []
        });
        if (m.value = !1, l) {
          M.value = l;
          const o = [
            { name: "openModel", message: a("请选择开合方式"), type: "" },
            { name: "flowerType", message: a("请选择花边类型"), type: "" },
            { name: "deliveryMethod", message: a("请选择配送方式"), type: "" },
            { name: "urgent", message: a(""), type: "" },
            { name: "roomName", message: a("请输入"), type: "" }
            // { name: 'productLength', message: t('请输入'), type: '' }
          ], i = [
            { name: "openModel", message: a("请选择开合方式"), type: "" },
            { name: "flowerType", message: a("请选择花边类型"), type: "" },
            { name: "deliveryMethod", message: a("请选择配送方式"), type: "" },
            { name: "urgent", message: a(""), type: "" },
            { name: "roomName", message: a("请输入"), type: "" },
            { name: "productHeight", message: a("请输入"), type: "" },
            { name: "productWidth", message: a("请输入"), type: "" },
            { name: "productLength", message: a("请输入"), type: "" }
          ];
          ee(o, l), Z(i, l);
        }
      } catch (l) {
        m.value = !1, x.error("获取数据失败"), console.error("数据获取错误:", l);
      }
    }), ne = () => {
      Object.assign(t, {
        flowerType: "竖向花边",
        productLength: 0,
        openModel: "",
        productHeight: null,
        productWidth: null,
        pleatinMultiple: "",
        roomName: "",
        isStandard: "否",
        urgent: "否",
        deliveryMethod: ""
      });
    };
    return j(
      () => t.flowerType,
      (s) => {
        var l;
        (l = w.value) == null || l.restoreValidation(), s === "横向花边" ? (t.openModel = "", t.productHeight = null) : (t.pleatinMultiple = "", t.productWidth = null);
      }
    ), j(
      () => I.options,
      (s) => {
        ne(), Object.keys(t).forEach((l) => {
          if (s[l] !== void 0) {
            const o = Object.keys(t).find(
              (i) => i === i && s.hasOwnProperty(i)
            );
            o && (t[o] = s[o]);
          }
        }), t.flowerType === "横向花边" ? (t.openModel = "", t.productHeight = null) : t.flowerType === "竖向花边" && (t.pleatinMultiple = "", t.productWidth = null), z();
      },
      { immediate: !0, deep: !0 }
    ), we(() => {
      z();
      const s = sessionStorage.getItem("userInfo");
      te.value = s ? JSON.parse(s) : null;
    }), u({
      formRef: w,
      loading: m,
      isShowDialog: E,
      formData: t
    }), (s, l) => (F(), K(be, null, [
      v("div", {
        ref_key: "lianshenHuabian",
        ref: H
      }, null, 512),
      r(e(Le), {
        bordered: "",
        show: E.value,
        "onUpdate:show": l[9] || (l[9] = (o) => E.value = o),
        "mask-closable": !1,
        to: H.value || "body",
        class: "tw:!text-left"
      }, {
        default: n(() => [
          r(e(xe), {
            class: "tw:!w-[50%] tw:!box-border tw:!text-left",
            title: e(a)("帘身花边"),
            bordered: !1,
            role: "dialog",
            closable: "",
            onClose: D,
            "header-class": "tw:!text-center"
          }, {
            default: n(() => [
              r(e(_e), { show: m.value }, {
                default: n(() => [
                  r(e(Ce), {
                    model: e(t),
                    rules: oe.value,
                    size: "small",
                    ref_key: "formRef",
                    ref: w,
                    "label-placement": "left",
                    "label-width": "140px",
                    "require-mark-placement": "right-hanging",
                    class: "tw:!text-left"
                  }, {
                    default: n(() => [
                      r(e(Te), null, {
                        default: n(() => [
                          r(e(h), { span: 24 }, {
                            default: n(() => [
                              r(e(g), {
                                label: e(a)("花边类型"),
                                path: "flowerType"
                              }, {
                                default: n(() => [
                                  r(e(R), {
                                    disabled: !c("flowerType"),
                                    value: e(t).flowerType,
                                    "onUpdate:value": [
                                      l[0] || (l[0] = (o) => e(t).flowerType = o),
                                      se
                                    ],
                                    placeholder: e(a)("请选择花边类型"),
                                    options: L("flowerType"),
                                    "label-field": "value",
                                    "value-field": "valueCode",
                                    "key-field": "valueCode",
                                    class: "tw:!w-[50%] tw:!text-left",
                                    to: !1
                                  }, null, 8, ["disabled", "value", "placeholder", "options"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          r(e(h), { span: 24 }, {
                            default: n(() => [
                              r(e(g), {
                                label: e(a)("开合方式"),
                                path: "openModel"
                              }, {
                                default: n(() => [
                                  r(e(R), {
                                    disabled: !c("openModel") || e(t).flowerType === "横向花边",
                                    value: e(t).openModel,
                                    "onUpdate:value": l[1] || (l[1] = (o) => e(t).openModel = o),
                                    placeholder: e(a)("请选择开合方式"),
                                    options: L("openModel"),
                                    "label-field": "value",
                                    "value-field": "valueCode",
                                    "key-field": "valueCode",
                                    class: "tw:!w-[50%] tw:!text-left",
                                    to: !1
                                  }, null, 8, ["disabled", "value", "placeholder", "options"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          r(e(h), { span: 24 }, {
                            default: n(() => [
                              r(e(g), {
                                label: e(a)("打褶倍数"),
                                path: "pleatinMultiple"
                              }, {
                                default: n(() => [
                                  r(e(R), {
                                    disabled: !c("pleatinMultiple") || e(t).flowerType === "竖向花边",
                                    value: e(t).pleatinMultiple,
                                    "onUpdate:value": l[2] || (l[2] = (o) => e(t).pleatinMultiple = o),
                                    placeholder: e(a)("请选择打褶倍数"),
                                    options: L("pleatinMultiple"),
                                    "label-field": "value",
                                    "value-field": "valueCode",
                                    "key-field": "valueCode",
                                    class: "tw:!w-[50%] tw:!text-left",
                                    to: !1
                                  }, null, 8, ["disabled", "value", "placeholder", "options"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          r(e(h), { span: 24 }, {
                            default: n(() => [
                              r(e(g), {
                                label: e(a)("成品高"),
                                path: "productHeight"
                              }, {
                                default: n(() => [
                                  (F(), Q(e(B), {
                                    disabled: !c("productHeight") || e(t).flowerType === "横向花边",
                                    value: e(t).productHeight,
                                    "onUpdate:value": l[3] || (l[3] = (o) => e(t).productHeight = o),
                                    key: `productWidth-${e(t).flowerType}`,
                                    "show-button": !1,
                                    min: 0,
                                    class: "tw:!w-[100%] tw:!text-center"
                                  }, {
                                    suffix: n(() => l[10] || (l[10] = [
                                      v("span", null, "mm", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["disabled", "value"]))
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          r(e(h), { span: 24 }, {
                            default: n(() => [
                              r(e(g), {
                                label: e(a)("成品宽"),
                                path: "productWidth"
                              }, {
                                default: n(() => [
                                  (F(), Q(e(B), {
                                    disabled: !c("productWidth") || e(t).flowerType === "竖向花边",
                                    value: e(t).productWidth,
                                    "onUpdate:value": l[4] || (l[4] = (o) => e(t).productWidth = o),
                                    key: `productWidth-${e(t).flowerType}`,
                                    "show-button": !1,
                                    min: 0,
                                    class: "tw:!w-[100%] tw:!text-center"
                                  }, {
                                    suffix: n(() => l[11] || (l[11] = [
                                      v("span", null, "mm", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["disabled", "value"]))
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          r(e(h), { span: 24 }, {
                            default: n(() => [
                              r(e(g), {
                                label: e(a)("花边长度"),
                                path: "productLength"
                              }, {
                                default: n(() => [
                                  v("div", We, [
                                    r(e(B), {
                                      value: e(t).productLength,
                                      "onUpdate:value": l[5] || (l[5] = (o) => e(t).productLength = o),
                                      "show-button": !1,
                                      min: 0,
                                      class: "tw:!w-[100%] tw:!text-center",
                                      disabled: ""
                                    }, {
                                      suffix: n(() => l[12] || (l[12] = [
                                        v("span", null, "mm", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["value"]),
                                    le.value && c("productLength") ? (F(), K("span", {
                                      key: 0,
                                      onClick: ae,
                                      class: "tw:cursor-pointer tw:text-[#fc9153] tw:ml-[10px] tw:w-[60px]"
                                    }, b(e(a)("计算")), 1)) : ye("", !0)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          r(e(h), { span: 24 }, {
                            default: n(() => [
                              r(e(g), {
                                label: e(a)("房间名"),
                                path: "roomName"
                              }, {
                                default: n(() => [
                                  r(e(ke), {
                                    disabled: !c("roomName"),
                                    value: e(t).roomName,
                                    "onUpdate:value": l[6] || (l[6] = (o) => e(t).roomName = o),
                                    placeholder: "",
                                    class: "tw:!w-[50%]"
                                  }, null, 8, ["disabled", "value"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          r(e(h), { span: 24 }, {
                            default: n(() => [
                              r(e(g), {
                                label: e(a)("配送方式"),
                                path: "deliveryMethod"
                              }, {
                                default: n(() => [
                                  r(e(R), {
                                    disabled: !c("deliveryMethod"),
                                    value: e(t).deliveryMethod,
                                    "onUpdate:value": l[7] || (l[7] = (o) => e(t).deliveryMethod = o),
                                    placeholder: "{{ t('请选择配送方式') }}",
                                    options: L("deliveryMethod"),
                                    "label-field": "value",
                                    "value-field": "valueCode",
                                    "key-field": "valueCode",
                                    class: "tw:!w-[50%] tw:!text-left",
                                    to: !1
                                  }, null, 8, ["disabled", "value", "options"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          r(e(h), { span: 24 }, {
                            default: n(() => [
                              r(e(g), {
                                label: e(a)("是否加急"),
                                path: "urgent"
                              }, {
                                default: n(() => [
                                  r(e(He), {
                                    disabled: !c("urgent"),
                                    value: e(t).urgent,
                                    "onUpdate:value": l[8] || (l[8] = (o) => e(t).urgent = o)
                                  }, {
                                    default: n(() => [
                                      r(e(X), { value: "是" }, {
                                        default: n(() => [
                                          U(b(e(a)("是")), 1)
                                        ]),
                                        _: 1
                                      }),
                                      r(e(X), { value: "否" }, {
                                        default: n(() => [
                                          U(b(e(a)("否")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "value"]),
                                  v("span", Se, "  (" + b(e(a)("注：加急需收取加急费35元")) + ") ", 1)
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      v("div", Fe, [
                        r(e(Y), {
                          onClick: D,
                          size: "small"
                        }, {
                          default: n(() => [
                            U(b(e(a)("取消")), 1)
                          ]),
                          _: 1
                        }),
                        r(e(Y), {
                          type: "primary",
                          onClick: re,
                          size: "small"
                        }, {
                          default: n(() => [
                            U(b(e(a)("确定")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  lt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/lianshenhuabian/lianshenhuabian.vue2.js
// module id = 1263
// module chunks = 67